import React from 'react';
import { MBReactionButtonWithPicker } from '../components/reaction/buttonWithPicker';
import { useSelectedReactions, useToggleReaction } from './hooks';

type OwnProps = Omit<MBReactionButtonWithPicker['props'], 'onToggleReaction' | 'selected'> & {
  message: MBAPI.ChatMessage;
  channelSlug: string;
};

export function MBMessageReactionButton({ message, channelSlug }: OwnProps) {
  const selected = useSelectedReactions(message);
  const toggleReaction = useToggleReaction(message, channelSlug);
  return (
    <MBReactionButtonWithPicker
      selected={selected}
      onToggleReaction={toggleReaction}
      testID="chat-message-reaction-button"
    />
  );
}
